/** Cobrança de convênio pendente que só recebe baixa pela conciliação em Planos de Saúde. */
export function isAwaitingInsuranceSettlement(row: any): boolean {
  const meta = row?.metadata?.insurance_payment;
  if (meta?.settle_on_confirmation !== true || meta?.confirmation_status === 'confirmed') return false;
  const isInsurance = Boolean(row?.insurance_id) || String(row?.payment_method || '').toLowerCase() === 'convenio';
  return isInsurance && ['pending', 'overdue'].includes(String(row?.status || '').toLowerCase());
}

export const AWAITING_INSURANCE_SETTLEMENT_LABEL = 'Aguardando conciliação do plano';
